export default "__VITE_ASSET__COBX04NL__"